import * as Sentry from "@sentry/tanstackstart-react";
import { IconAlertTriangle } from "@tabler/icons-react";
import { type ErrorComponentProps, Link, useCanGoBack, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "@/components/ui/empty";

export function ErrorComponent({ error }: ErrorComponentProps) {
	const router = useRouter();
	const canGoBack = useCanGoBack();

	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<div className="flex flex-1 items-center justify-center p-4">
			<Empty className="w-full">
				<EmptyHeader>
					<EmptyMedia variant="icon" className="bg-destructive/5 text-destructive">
						<IconAlertTriangle />
					</EmptyMedia>
           <EmptyTitle>An error occurred</EmptyTitle>
					<EmptyDescription>
						An error occurred while loading the requested resource. Please try again later.
					</EmptyDescription>
					{error.message && <EmptyDescription>{error.message}</EmptyDescription>}
				</EmptyHeader>
				<EmptyContent className="flex-row justify-center">
					<Button variant="outline" size="sm" onClick={() => router.invalidate()}>
						Try Again
					</Button>
					{canGoBack ? (
						<Button variant="outline" size="sm" onClick={() => router.history.back()}>
							Back
						</Button>
					) : null}
					<Button
						variant="outline"
						size="sm"
						nativeButton={false}
						render={<Link to="/">Go to homepage</Link>}
					/>
				</EmptyContent>
			</Empty>
		</div>
	);
}
